import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AppState } from "../store/core.state";
import { combineLatest, filter, map, Observable, of, switchMap, take } from "rxjs";
import { getCongressmenDatatype, getLegislation, getParties, getStates, getVoteTypes } from "../store/core.actions";
import { selectCongressmenDisplayNames, selectLegislation, selectParties, selectStates, selectVoteTypes } from "../store/core.selector";
import { RedirectCommand } from "@angular/router"; 

@Injectable({ providedIn: 'root' })
export class LookupsResolver {
  constructor(private store: Store<AppState>) {}

  resolve(): Observable<boolean | RedirectCommand> { 
    return combineLatest([
      this.store.pipe(select(selectStates)),
      this.store.pipe(select(selectLegislation)),
      this.store.pipe(select(selectVoteTypes)),
      this.store.pipe(select(selectCongressmenDisplayNames)),
      this.store.pipe(select(selectParties))
    ]).pipe(
      take(1),
      switchMap(([states, legislation, voteTypes, congressmen, parties]) => {
        const needsStates = !states || states.length === 0;
        const needsLegislation = !legislation || legislation.length === 0;
        const needsVoteTypes = !voteTypes || voteTypes.length === 0;
        const needsCongressmen = !congressmen || congressmen.length === 0;
        const needsParties = !parties || parties.length === 0;

        if (needsStates) this.store.dispatch(getStates());
        if (needsLegislation) this.store.dispatch(getLegislation());
        if (needsVoteTypes) this.store.dispatch(getVoteTypes());
        if (needsCongressmen) this.store.dispatch(getCongressmenDatatype());
        if (needsParties) this.store.dispatch(getParties());

        if (!needsStates && !needsLegislation && !needsVoteTypes && !needsCongressmen && !needsParties)
          return of(true);

        return combineLatest([
          this.store.pipe(select(selectStates)),
          this.store.pipe(select(selectLegislation)),
          this.store.pipe(select(selectVoteTypes)),
          this.store.pipe(select(selectCongressmenDisplayNames)),
          this.store.pipe(select(selectParties))
        ]).pipe(
          filter(([s, l, v, c, p]) =>
            s?.length > 0 && l?.length > 0 && v?.length > 0 &&
            c?.length > 0 && p?.length > 0
          ),
          take(1),
          map(() => true)
        );
      })
    );
  }
}